export const frequenciesListArray = [
  {
    id: 1,
    atcName: 'Cancun',
    frequency: 'Ground',
    atcEntity: '121.9',
    schedule: 'H24',
  },
  {
    id: 2,
    atcName: 'Cancun',
    frequency: 'Ground',
    atcEntity: '121.9',
    schedule: 'Mon-Fri 07:00/17:00',
  },
  {
    id: 3,
    atcName: 'Cancun',
    frequency: 'Ground',
    atcEntity: '121.9',
    schedule: 'H24',
  },
];

export const frequenciesHeadersArray = [
  { title: 'ATC Name', field: 'atcName' },
  { title: 'Frequency', field: 'frequency' },
  { title: 'ATC Entity', field: 'atcEntity' },
  { title: 'Schedule', field: 'schedule' },
  { title: 'Remarks', field: 'remarks' },
];

export const atcFrequency = [
  { itemValue: 'ATIS', itemLabel: 'ATIS' },
  { itemValue: 'D-ATIS', itemLabel: 'D-ATIS' },
  { itemValue: 'TOWER', itemLabel: 'TOWER' },
  { itemValue: 'CLEARANCE', itemLabel: 'CLEARANCE' },
  { itemValue: 'DEPARTURE', itemLabel: 'DEPARTURE' },
  { itemValue: 'AWOS', itemLabel: 'AWOS' },
  { itemValue: 'CPDLC', itemLabel: 'CPDLC' },
  { itemValue: 'RAMP CTL', itemLabel: 'RAMP CTL' },
  { itemValue: 'TERMINAL', itemLabel: 'TERMINAL' },
  { itemValue: 'UNICOM', itemLabel: 'UNICOM' },
  { itemValue: 'CTAF', itemLabel: 'CTAF' },
  { itemValue: 'GROUND', itemLabel: 'GROUND' },
  { itemValue: 'APPROACH', itemLabel: 'APPROACH' },
  { itemValue: 'OTHER', itemLabel: 'OTHER' },
];
